import { FC } from 'react';

import { GTMEventLogger } from 'utils/GTMEventLogger';

import { GTMEvents } from 'constants/enums';

import { ReactComponent as BriefcaseIcon } from 'assets/icons/briefcase.svg';
import { ReactComponent as MessageIcon } from 'assets/icons/messageNotification.svg';
import { ReactComponent as NotificationStatusIcon } from 'assets/icons/notificationStatus.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/profileUser.svg';

import InfoSection from './InfoSection';

const InfoList: FC = () => (
  <div>
    <InfoSection icon={<BriefcaseIcon />} title="Looking to represent Joblio?">
      Learn more about our Ambassadorship Program by emailing{' '}
      <a
        href="mailto: ambassador@joblio.co"
        onClick={() => GTMEventLogger(GTMEvents.HomeAmbassadorSignupClick)}
      >
        ambassador@joblio.co
      </a>
    </InfoSection>
    <InfoSection icon={<ProfileIcon />} title="Looking to hire?">
      Sign up{' '}
      <a
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => GTMEventLogger(GTMEvents.HomeEmployerSignupClick)}
      >
        here
      </a>
    </InfoSection>
    <InfoSection icon={<NotificationStatusIcon />} title="Looking for work?">
      <a
        href="https://join.joblio.co/"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => GTMEventLogger(GTMEvents.HomeJobseekerSignupClick)}
      >
        join.joblio.co
      </a>{' '}
      is your best bet!
    </InfoSection>
    <InfoSection icon={<MessageIcon />} title="Media requests?">
      Send email to{' '}
      <a
        href="mailto: media@joblio.co"
        onClick={() => GTMEventLogger(GTMEvents.HomeMediaSignupClick)}
      >
        media@joblio.co
      </a>
    </InfoSection>
  </div>
);

export default InfoList;
